<template>
  <div>
    <v-card class="pa-8 ma-8" stle="opacity:0.8;">
      <h1 class="text-center">Terms and Conditions</h1>

      <div class="text-center mt-7">
        <v-btn
          color="accent white--text"
          clas="mt-7"
          @click="ShowPDFClicked = true"
        >
          Terms and Conditions &nbsp;&nbsp;
          <span style="padding-left: 3px; font-size: 16px">
            <v-icon color="orange">mdi-book</v-icon>
          </span>
        </v-btn>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Terms',
  data() {
    return {
      ShowPDFClicked: false,
    };
  },
  metaInfo: {
    title: 'Terms and Conditions',
    titleTemplate: 'Strapp - T&Cs 📄',
    content:
      'An online rental marketplace where you can rent out your household items and equipment to others for short term periods.',
    htmlAttrs: { lang: 'en' },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
  },
};
</script>

<style lang="scss" scoped></style>
